/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1Boolean
 */
export interface ApiResponse1Boolean {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1Boolean
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1Boolean
     */
    message?: string | null;
    /**
     * Response data'sı
     * @type {boolean}
     * @memberof ApiResponse1Boolean
     */
    data?: boolean;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1Boolean
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1Boolean interface.
 */
export function instanceOfApiResponse1Boolean(value: object): value is ApiResponse1Boolean {
    return true;
}

export function ApiResponse1BooleanFromJSON(json: any): ApiResponse1Boolean {
    return ApiResponse1BooleanFromJSONTyped(json, false);
}

export function ApiResponse1BooleanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1Boolean {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : json['data'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1BooleanToJSON(json: any): ApiResponse1Boolean {
    return ApiResponse1BooleanToJSONTyped(json, false);
}

export function ApiResponse1BooleanToJSONTyped(value?: ApiResponse1Boolean | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': value['data'],
        'errors': value['errors'],
    };
}

